import { Navigate, useParams } from 'react-router';

import LoadingIndicator from '@/components/LoadingIndicator';
import { useFetchLegacyTicket } from '@/pages/Ticket/Ticket.store';

import type { LegacyRouteHandlerProps } from './LegacyRouteHandler.types';

const LegacyRouteHandler = (props: LegacyRouteHandlerProps) => {
  const { routeType } = props;
  const { id } = useParams();
  const { isPending, mutate } = useFetchLegacyTicket();

  // handle legacy conversation routes
  // find new Scope 2 id assign to legacy Scope 1 conversation
  if (routeType === 'conversation') {
    const requestBody = { legacy_conversation_id: id };
    if (isPending) {
      return <LoadingIndicator isLoading={isPending} />;
    }
    mutate(requestBody);
    return null;
  }

  // handle legacy ticket routes
  // note: new route is same as old route - not found page is already handled
  if (routeType === 'ticket') {
    return <Navigate to={`/ticket/${id}`} replace />;
  }

  // fallback
  return <Navigate to="/not-found" replace />;
};
export default LegacyRouteHandler;
